import React, { useEffect } from "react";

import {
  RideFiFamilyLight,
  RideSpinner,
} from "@rimac-seguros/ride-system-components";

import { QUOTE_MESSAGE } from "./constants";
import helpers from "@/utils/helpers";
import { Modal } from "@/components/molecules/NewModal";
import { useSelector } from "react-redux";
import { StateMachine } from "@/utils/consts";
import { getProductOptions } from "@/utils/product";

export const ModalLoading = () => {
  const isVE = helpers.validateVidaEndosable();
  const { productName } = getProductOptions();
  const { modalLoading, state } = useSelector((state) => state.global);

  useEffect(() => {
    if (modalLoading === QUOTE_MESSAGE && state !== StateMachine[14]) {
      helpers.getTagVirtual(`sol:comprar:${productName}:loader-cotizacion`);
    }
  }, [modalLoading]);

  if (!modalLoading) {
    return null;
  }
  
  return (
    <Modal
      isOpen={!!modalLoading}
      fullContentOnlyMobile
      iconClose={false}
      backDropClose={false}
      className="col-span-full md:col-span-8 md:col-start-3 lg:col-span-6 lg:col-start-4"
    >
      <div
        className={`
        flex 
        flex-col
        items-center 
        justify-center 
        h-full 
        gap-10 
        lg:bg-ride-sys-color-background-default 
        lg:rounded-3xl 
        lg:h-auto 
        lg:px-16
        lg:py-ride-gl-spacing-9xlarge
        lg:gap-ride-gl-spacing-2xlarge
      `}
      >
        <RideFiFamilyLight />
        <div className="flex flex-col gap-ride-gl-spacing-large">
          <p
            className={`text-center ride-sys-text-title-3xlarge-default lg:ride-sys-text-title-2xlarge-default ${
              isVE ? "max-w-xs md-special:max-w-none" : ""
            }`}
          >
            {modalLoading}
          </p>
          <p className="text-center ride-sys-text-paragraph-large-default">
            Cargando...
          </p>
        </div>
        <RideSpinner size="large" />
      </div>
    </Modal>
  );
};
